import Alma from '../../../icons/Alma';
import { Config } from '../../../../config';
import React from 'react';
const Trigger = ({ hasBot, showBot, handleToggle }) => {
  return (
    <button 
      className="chatbot_trigger" 
      data-active={ hasBot } 
      onClick={ handleToggle }
    >
      { showBot ? 'Close' : 'Open'} { Config.chatbot.name }
      <Alma/>
    </button>
  )
};

export default Trigger;